module.exports = __webpack_public_path__ + "static/media/statekosong.7eb0e8ed.png";